import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/Dashboard.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <aside className="sidebar">
      {/* Live Intelligence */}
      <div className="nav-section">
        <div
          className={`nav-item ${isActive('/dashboard/live-intelligence') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/live-intelligence')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          <span>Live Intelligence</span>
        </div>
      </div>

      {/* Compliance Terminal */}
      <div className="nav-section">
        <div className="nav-section-title">COMPLIANCE TERMINAL</div>
        <div
          className={`nav-item ${isActive('/dashboard/compliance-operator') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/compliance-operator')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
          <span>Compliance Operator</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/vault') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/vault')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <span>Vault</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/ledger') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/ledger')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span>LEDGER</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/regulatory-heat-map') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/regulatory-heat-map')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <line x1="18" y1="20" x2="18" y2="10"/>
            <line x1="12" y1="20" x2="12" y2="4"/>
            <line x1="6" y1="20" x2="6" y2="14"/>
          </svg>
          <span>Regulatory Heat Map</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/document-library') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/document-library')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
          </svg>
          <span>Document Library</span>
        </div>
      </div>

      {/* Verification */}
      <div className="nav-section">
        <div className="nav-section-title">VERIFICATION</div>
        <div
          className={`nav-item ${isActive('/dashboard/ekyb-verification') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/ekyb-verification')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
          <span>eKYB Verification</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <span>Ownership Search</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span>Sanctions Screen</span>
        </div>
      </div>

      {/* Regulatory Coverage */}
      <div className="nav-section">
        <div className="nav-section-title">REGULATORY COVERAGE</div>
        <div
          className={`nav-item ${isActive('/dashboard/authorities') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/authorities')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <span>Authorities & Regulators</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/nordic-baltic') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/nordic-baltic')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"/>
            <line x1="2" y1="12" x2="22" y2="12"/>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
          <span>Nordic-Baltic NCAs</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/regulatory-coverage') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/regulatory-coverage')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
          <span>EU Frameworks</span>
        </div>
        <div
          className={`nav-item ${isActive('/dashboard/mica') ? 'active' : ''}`}
          onClick={() => navigate('/dashboard/mica')}
          style={{cursor: 'pointer'}}
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          <span>MiCA Register</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M12 2l9 4.9V12c0 5.5-3.8 10.7-9 12-5.2-1.3-9-6.5-9-12V6.9L12 2z"/>
          </svg>
          <span>MiCA Framework</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <span>DORA</span>
        </div>
      </div>

      {/* Account */}
      <div className="nav-section">
        <div className="nav-section-title">ACCOUNT</div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
          </svg>
          <span>Billing & Usage</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
          </svg>
          <span>API Keys</span>
        </div>
        <div className="nav-item disabled">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v6m0 6v6m5.196-17.196L13.5 5.5m-3 3l-3.696-3.696M1 12h6m6 0h6m-17.196 5.196L5.5 13.5m3-3l-3.696 3.696M12 23v-6m0-6V1M17.196 1.804L13.5 5.5m-3 3l3.696 3.696"/>
          </svg>
          <span>Settings</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
